<template>
  <v-menu content-class="mt-2" open-on-hover offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div
        :class="
          shadowVariant
            ? 'message-reaction-pill--shadow'
            : 'message-reaction-pill--outline'
        "
        class="message-reaction-pill rounded-xl px-2 py-1 mr-2 pointer"
        v-bind="attrs"
        v-on="on"
      >
        <!-- Reaction emoji -->
        <span v-html="reactionEmoji"></span>
        <!-- Reactions count -->
        <span class="reaction-count font10">{{
          getNumberOfReactingUsers
        }}</span>
      </div>
    </template>
    <v-list class="px-4 py-3">
      <!-- Reaction Name -->
      <div class="font12 mb-2 text-capitalize">
        {{ reactionDetails.reaction }}
      </div>
      <!-- List of reacting users -->
      <v-list-item
        v-for="userId in reactionDetails.userIds"
        :key="userId"
        class="pa-0"
      >
        <v-list-item-title>
          <v-row no-gutters align="center">
            <x-avatar
              :text="getUserNameInitials(reactingPersonName(userId), true)"
              size="20"
              textSize="10"
            />
            <div class="ml-2 font14">
              {{ reactingPersonName(userId) }}
            </div>
          </v-row>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { getEmojiByName } from '@/helpers/emojiResolver';
export default {
  name: 'message-reaction-pill',
  props: {
    reactionDetails: {
      type: Object,
      required: true
    },
    shadowVariant: {
      type: Boolean
    },
    chatAccessibleBy: Array
  },
  data() {
    return {
      getEmojiByName
    };
  },
  computed: {
    getNumberOfReactingUsers() {
      return (this.reactionDetails?.userIds || []).length;
    },
    reactionEmoji() {
      return getEmojiByName(this.reactionDetails.reaction);
    },
    reactingPersonName() {
      /**
       * @param {String} userId
       */
      return userId => {
        let personName = this.formatUserName(this.userIdNameMap[userId]);

        // If userId not found in user details of org, then use chatAccessibleBy
        if (!personName) {
          const accessibleUserDetails = this.chatAccessibleBy.find(
            userDetails => userDetails?.userId === userId
          );
          personName = this.getMessageSenderName(accessibleUserDetails || {});
        }
        return personName;
      };
    }
  }
};
</script>
<style scoped>
.message-reaction-pill {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  background-color: #fff;
}
.message-reaction-pill--shadow {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.message-reaction-pill--outline {
  box-shadow: none;
  border: 1px solid #ccc;
}
.v-avatar span {
  font-size: 12px;
}

.v-list-item {
  min-height: 40px !important;
}
</style>
